require('./dist/select.js');
module.exports = 'ui.select';



//////////////////
// WEBPACK FOOTER
// ./~/ui-select/index.js
// module id = 15
// module chunks = 2